<template>
  <div>
    <router-view />
  </div>
</template>

<script>
// import eventsHub from './main.js'

export default {
  name: 'App',
  beforeCreate() {
    this.$store.dispatch('setUser', {
      requestOptions: { meta: { throwError: false } }
    })
    this.axios.interceptors.request.use(request => {
      return request
    })
    this.axios.interceptors.response.use(
      response => {
        return response
      },
      error => {
        // Check if error.response exists (network errors don't have response)
        if (!error.response) {
          return Promise.reject(error)
        }

        switch (error.response.status) {
          case 401:
            this.$store
              .dispatch('logout', { requestOptions: { method: 'GET' } })
              .then(() => {
                if (this.$toast) {
                  this.$toast.add({
                    severity: 'error',
                    summary: 'Authentication Error',
                    detail: error.response.data.message || 'Session expired',
                    life: 3000
                  })
                }
                this.$router.push({ name: 'login', params: '' })
              })
            break
          case 404:
            var message = error.response.data.message
            var errors = error.response.data.errors
            if (this.$toast) {
              this.$toast.add({
                severity: 'error',
                summary: 'Not Found',
                detail: message,
                life: 3000
              })
              if (errors) {
                for (var key in errors) {
                  var err = errors[key]
                  if (err && err.length) {
                    for (const errorText of err) {
                      this.$toast.add({
                        severity: 'error',
                        summary: 'Validation Error',
                        detail: errorText,
                        life: 3000
                      })
                    }
                  }
                }
              }
            }
            break
          case 504:
            if (this.$toast) {
              this.$toast.add({
                severity: 'error',
                summary: 'Timeout',
                detail: 'Timeout, Silahkan coba lagi!!!',
                life: 3000
              })
            }
            break
          default:
            break
        }
        return Promise.reject(error)
      }
    )
  },

  created() {
    setTimeout(() => {
      if (
        this.$store.state.isAuthenticated &&
        this.$store.state.user.role == 'CASHIER'
      ) {
        let idleTimer = null
        const resetIdleTimer = () => {
          if (idleTimer) {
            clearInterval(idleTimer)
            idleTimer = null
          }
          idleTimer = setInterval(() => {
            this.logout()
          }, process.env.VUE_APP_IDLE_TIME)
        }
        document.addEventListener('mousemove', () => {
          if (!idleTimer) {
            return
          }
          resetIdleTimer()
        })
        document.addEventListener('keypress', () => {
          if (!idleTimer) {
            return
          }
          resetIdleTimer()
        })
        resetIdleTimer()
        // adda eventlistener for "idle"
        document.addEventListener('idle', () => {
          clearInterval(idleTimer)
          idleTimer = null
          console.log('You have been idle for too long. Logging out...')
        })
      }
    }, 500)
  },

  methods: {
    logout() {
      this.$store
        .dispatch('logout', { requestOptions: { method: 'POST' } })
        .then(() => {
          this.$router.go()
          this.$router.push({ name: 'login' })
        })
    }
  }
}
</script>

<style></style>
